<template>
  <div class="wrap">正在授权中，请稍候...</div>
</template>

<script>
import { defineComponent, onMounted } from "@vue/composition-api";
import Vue from "vue";

import { useRoute } from "@/components/use/base";

const vm = Vue.prototype;

export default defineComponent({
  setup() {
    const route = useRoute();

    const alipayAuth = () => {
      const { redirect_uri } = route.query;
      const appId = vm.$getConfigValue("ALIPAY_AUTH_APPID");
      if (!redirect_uri) {
        vm.$toast("缺少回调地址");
        return;
      }
      if (!appId) {
        vm.$toast("缺少支付宝授权appid");
        return;
      }
      setTimeout(() => {
        const authUrl = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=${appId}&scope=auth_base&redirect_uri=${redirect_uri}`;
        window.location.href = authUrl;
      }, 1000);
    };

    onMounted(() => {
      alipayAuth();
    });
  },
});
</script>

<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #333;
}
</style>
